// extracted by mini-css-extract-plugin
module.exports = {"delta2_p1":"Group1_delta2_p1__605Ix"};